import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class NavService {
    // Observable navItem source
    private _navItemSource = new BehaviorSubject<number>(0);
    // Observable navItem stream
    navItem$ = this._navItemSource.asObservable();
    // service command

    private _Login = new BehaviorSubject<boolean>(true);
    Login$ = this._Login.asObservable();

    private _onNotification = new BehaviorSubject<any>(null);
    onNotification$ = this._onNotification.asObservable();

    private _walletBalance = new BehaviorSubject<any>(null);
    walletBalance$ = this._walletBalance.asObservable();


    changeNav(number) {
        this._navItemSource.next(number);
    }

    LoginAfter(login) {
        this._Login.next(login);
    }

    OnNotification(msg) {
        this._onNotification.next(msg);
    }

    updateWallet(balance) {
        this._walletBalance.next(balance);
    }

}